import React, { Component } from 'react'
import CameraNotAccessibleModal from 'components/CameraNotAccessibleModal'

export function withMediaAvailabilityCheck(WrappedComponent) {
  return class extends Component {
    constructor(props) {
      super(props)
      this.state = {
        audioAccessible: undefined,
        videoAccessible: undefined
      }
    }

    componentDidMount() {
      this.verifyMedia('audio')
      this.verifyMedia('video')
    }

    verifyMedia(type) {
      if (!navigator.mediaDevices) return
      const constraints = { [type]: true }
      navigator.mediaDevices.getUserMedia(constraints)
        .then((stream) => {
          this.setState({ [`${type}Accessible`]: true })
          stream.getTracks().forEach(track => track.stop())
        })
        .catch(() => {
          this.setState({ [`${type}Accessible`]: false })
        })
    }

    render() {
      const {
        appointmentId,
        jwt,
        redirectURL
      } = this.props
      const {
        audioAccessible,
        videoAccessible
      } = this.state
      if (audioAccessible === false || videoAccessible === false) {
        return (
          <CameraNotAccessibleModal
            show={true}
            appointmentId={appointmentId}
            jwt={jwt}
            redirectURL={redirectURL}
            onClose={() => {
              window.location.reload()
            }}
          />
        )
      } else if (audioAccessible === undefined || videoAccessible === undefined) {
        return null
      }
      return (
        <WrappedComponent {...this.props} />
      )
    }
  }
}
